import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import FormAccessoryComponent from '../components/FormAccessoryComponent';
import FormBoxGameComponent from '../components/FormBoxGameComponent';
import ProductBranchSettingsComponent from '../components/ProductBranchSettingsComponent';
import { validateSession } from '../utils/functions';
import {
    buildProductPayload,
    getProductImageFolder,
    getProductsListPath,
} from '../utils/productForm';
import { navigateTo } from '../utils/navigation';
import { clearProductImages, uploadProductImages } from '../utils/productImages';

var config = process.env;

class EditProductPage extends Component {

    constructor() {
        super();
        this.state = {
            uploadValue: 0,
            checked: false,
            disabled: false,
            role: 0,
            productType: null,
        };
    }

    async componentDidMount() {
        const code = this.getCode();
        if (code == null || code === '') {
            navigateTo('/products');
            return;
        }

        const role = await validateSession();
        this.setState({ checked: true, role });
        this.loadProductType(code);
    }

    getCode = () => {
        const params = new URLSearchParams(this.props.location.search);
        return params.get('code');
    }

    loadProductType = (code) => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product/' + code, request)
        .then(results => results.json())
        .then(data => {
            const detail = data?.data?.product || data?.data?.accessory;
            if (data.error > 0 || data.data == null || detail == null) {
                navigateTo('/products');
                return;
            }

            const productType = Number(detail.productType ?? 1);

            // Un usado NO se edita por esta ficha: tiene su propia pantalla, con el vendedor, la
            // condición y el crédito acordado. Guardarlo por acá lo convertía en juego nuevo y el
            // backend borraba su fila `used_game` con esos datos. Ahora el backend lo rechaza, así
            // que sin esta redirección el operador sólo vería un error sin explicación.
            if (productType === 3) {
                navigateTo(`/editUsedGame?code=${encodeURIComponent(this.getCode())}`);
                return;
            }

            this.setState({ productType });
        });
    }

    handleChangeData = (value) => {
        this.setState({ disabled: true });
        const request = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token')
            },
            body: JSON.stringify(buildProductPayload(value, this.state.productType, true))
        };

        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'product', request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                // Sin esto el guardado fallido solo re-habilitaba el botón, en silencio:
                // el operador se iba creyendo que había guardado. Mismo manejo que AddProductPage.
                alert(data.message);
                this.setState({ disabled: false });
                if (data.error === 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                // Los datos del producto YA se guardaron. Las imágenes son un paso aparte y sólo
                // se tocan si el form confirma que terminó de cargar las que ya estaban.
                if (value.imagesReady !== true) {
                    alert(
                        'Los datos se guardaron.\n\n'
                        + 'Las imágenes NO se tocaron porque todavía se estaban cargando las que el '
                        + 'producto ya tenía. Volvé a entrar, esperá a que aparezcan en la grilla y '
                        + 'guardá de nuevo si querés cambiarlas.',
                    );
                    this.redirect();
                    return;
                }
                this.setState({ uploadValue: 5 });
                this.deleteImages(value.images, value.code);
            }
        });
    }

    // Vaciar y reescribir la carpeta. Era un baile de listAll + N deletes encadenados por
    // contador en el state; ahora el borrado de la carpeta es una sola llamada al backend.
    //
    // Sigue siendo destructivo a propósito: el picker cargó las imágenes existentes al abrir la
    // pantalla y las reenvía, así que lo que se borra se vuelve a escribir.
    //
    // ⚠️ Esa premisa —"el picker YA las cargó"— es la única que sostiene todo el flujo, y no se
    // cumplía sola: la carga es asíncrona y nada bloqueaba el botón. El 2026-08-17 un producto
    // (Aqua) se guardó 2,6 s después de abrir la ficha, con las cuatro imágenes todavía en vuelo:
    // se borró la carpeta y no se subió nada. Por eso el guardado exige `imagesReady` arriba y el
    // form deshabilita "Guardar" mientras carga. Si alguna vez se cambia el orden acá, que sea
    // para subir ANTES de borrar, no para relajar la guarda.
    deleteImages = (images, code) => {
        const basePath = getProductImageFolder(this.state.productType, code);
        clearProductImages(basePath)
            .then(() => {
                this.setState({ uploadValue: 40 });
                return this.uploadImages(images, code);
            });
    }

    uploadImages = (images, code) => {
        const basePath = getProductImageFolder(this.state.productType, code);

        return uploadProductImages(basePath, images, (percent) => (
            this.setState({ uploadValue: 40 + (percent * 0.6) })
        ))
            .then(() => this.redirect())
            .catch((error) => {
                // Los cambios del producto YA se guardaron y las imágenes viejas ya se borraron:
                // si la subida falla y no se avisa, el producto queda SIN fotos. Antes esto se
                // tragaba con un console.log y ni siquiera redirigía — la pantalla se quedaba
                // colgada en la barra de progreso.
                alert(error.message || 'Los cambios se guardaron pero no se pudieron subir las imágenes');
                this.setState({ disabled: false, uploadValue: 0 });
            });
    }

    redirect = () => {
        navigateTo(getProductsListPath(this.state.productType));
    }

    renderForm = () => {
        const code = this.getCode();
        if (this.state.productType === 2) {
            return (
                <FormAccessoryComponent
                    code={code}
                    onChangeData={this.handleChangeData}
                    uploadValue={this.state.uploadValue}
                    disabled={this.state.disabled}
                    role={this.state.role}
                />
            );
        }

        return (
            <FormBoxGameComponent
                code={code}
                onChangeData={this.handleChangeData}
                uploadValue={this.state.uploadValue}
                disabled={this.state.disabled}
                role={this.state.role}
            />
        );
    }

    render() {
        if (!this.state.checked || this.state.productType == null) {
            return (<div></div>);
        }

        const code = this.getCode();
        const canManageBranchOverrides = Number(this.state.role) === 1;

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={4} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        {this.renderForm()}
                        {canManageBranchOverrides ? (
                            <div className="main-content-container container-fluid px-4">
                                <ProductBranchSettingsComponent code={code} />
                            </div>
                        ) : null}
                    </main>
                </div>
            </div>
        );
    }
}

export default EditProductPage;
